import React from "react";
import {CLOCK_IN_OUT, CLOCK_IN_OUT_PAGES} from "./constants";
import FeedbackBar from "../feedbackBar/FeedbackBar";
import withShipment from "../../withShipment";
import {statusSelector} from "../../redux/selectors/global";
import {clearStatus} from "../../redux/actions/global";
import "./ClockInOut.css"
import {userInfoSelector} from "../../redux/selectors/auth";
import TopToolbar from "../global/subcomponents/topToolbar/TopToolbar";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@material-ui/core";
import {clockRecordSelector} from "../../redux/selectors/settings";
import {clockIn, clockOut, loadClockRecords} from "../../redux/actions/settings";
import AccessTimeIcon from "@material-ui/icons/AccessTime";


class ClockInOut extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: CLOCK_IN_OUT_PAGES.TABLE,
      feedbackBarOpen: false,
      error: false,
      feedbackStatus: '',
      feedbackMessage: '',
      timeIn: null,
      timeOut: null,
      isDialogOpen: false,
      currentDuration: '00:00:00',
      intervalId: null,
      clockInProcessing: false
    };
  }

  componentDidMount() {
    this.props.loadClockRecords({ userId: this.props.user.userId });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.status.statusText &&
      prevProps.status.statusText !== this.props.status.statusText
    ) {
      this.openFeedbackBar(this.props.status.statusText, 'error');
    }

    if (prevProps.clockRecord !== this.props.clockRecord) {
      const clockRecord = this.props.clockRecord;

      // Check if clockRecord is defined
      if (clockRecord) {
        const { timeIn, timeOut } = clockRecord;

        // Convert backend `timeIn` object to JavaScript `Date`
        if (timeIn) {
          const parsedTimeIn = new Date(
            timeIn.year,
            timeIn.monthValue - 1, // Month is 0-indexed in JS Date
            timeIn.dayOfMonth,
            timeIn.hour,
            timeIn.minute,
            timeIn.second,
            Math.floor(timeIn.nano / 1e6) // Convert nanoseconds to milliseconds
          );
          this.setState({ timeIn: parsedTimeIn }, this.startTimer);
        }

        if (timeOut) {
          const parsedTimeOut = new Date(
            timeOut.year,
            timeOut.monthValue - 1, // Month is 0-indexed in JS Date
            timeOut.dayOfMonth,
            timeOut.hour,
            timeOut.minute,
            timeOut.second,
            Math.floor(timeOut.nano / 1e6) // Convert nanoseconds to milliseconds
          );

          this.setState({ timeOut: parsedTimeOut }, this.stopTimer);
        }

        if (
          this.state.timeIn &&
          !this.state.timeOut &&
          prevState.timeIn !== this.state.timeIn
        ) {
          this.startTimer();
        }
      } else {
        console.warn('clockRecord is undefined');
      }
    }
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  handleClockOutClick = () => {
    this.setState({ isDialogOpen: true });
  };

  cancelClockOut = () => {
    this.setState({ isDialogOpen: false });
  };

  getGreeting = () => {
    // Create a date object for the current time in the America/Chicago timezone
    const currentTime = new Date().toLocaleString('en-US', {
      timeZone: 'America/Chicago',
    });

    // Extract the hour (0-23) from the current time in the Chicago timezone
    const currentHour = new Date(currentTime).getHours();

    if (currentHour >= 0 && currentHour < 12) {
      return 'Good Morning';
    } else if (currentHour >= 12 && currentHour < 17) {
      return 'Good Afternoon';
    } else if (currentHour >= 17 && currentHour < 20) {
      return 'Good Evening';
    } else {
      return 'Good Night';
    }
  };


  startTimer = () => {
    if (!this.state.intervalId) {
      // Start only if no timer is running
      const intervalId = setInterval(this.updateDuration, 1000);
      this.setState({ intervalId });
    }
  };

  stopTimer = () => {
    clearInterval(this.state.intervalId);
    this.setState({ intervalId: null });
  };

  clockIn = () => {
    this.setState({ clockInProcessing: true });

    const callback = (error, response) => {
      if (error) {
        this.openFeedbackBar('error', response);
      } else {
        this.openFeedbackBar('success', 'Clock Started');
        this.startTimer();
        window.location.reload();
      }
      this.setState({ clockInProcessing: false });
    };
    this.props.clockIn({  userId: this.props.user.userId}, callback );
  };

  confirmClockOut = () => {
    const callback = (error, response) => {
      if (error) {
        this.openFeedbackBar('error', response);
      } else {
        this.openFeedbackBar('success', 'Clock Stopped');
        this.stopTimer();
        window.location.reload();
      }
      this.cancelClockOut();
    };
    this.props.clockOut(
      {
        userId: this.props.user.userId,
      },
      callback
    );
  };

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState(
      { feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: '' },
      () => {
        this.props.clearStatus();
      }
    );
  };

  convertToChicagoTime = (date) => {
    return new Date(
      date.toLocaleString('en-US', { timeZone: 'America/Chicago' })
    );
  };

  updateDuration = () => {
    const { timeIn, timeOut } = this.state;

    if (timeIn) {
      // Use timeOut if available, otherwise use the current time in America/Chicago zone
      const endTime = timeOut || this.convertToChicagoTime(new Date());
      const diffInMs = endTime - timeIn;

      const hours = Math.floor(diffInMs / (1000 * 60 * 60))
        .toString()
        .padStart(2, '0');
      const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60))
        .toString()
        .padStart(2, '0');
      const seconds = Math.floor((diffInMs % (1000 * 60)) / 1000)
        .toString()
        .padStart(2, '0');

      this.setState({ currentDuration: `${hours}:${minutes}:${seconds}` });

      // If timeOut exists, clear any interval updating currentDuration
      if (timeOut && this.durationInterval) {
        clearInterval(this.durationInterval);
        this.durationInterval = null;
      }
    }
  };

  // updateDuration = () => {
  //     const { timeIn, timeOut } = this.state;
  //
  //     if (timeIn) {
  //         // If timeOut is set, calculate the total duration and stop further updates
  //         const endTime = timeOut || new Date(); // Use `timeOut` if it exists, otherwise use current time
  //         const diffInMs = endTime - timeIn;
  //
  //         const hours = Math.floor(diffInMs / (1000 * 60 * 60)).toString().padStart(2, '0');
  //         const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
  //         const seconds = Math.floor((diffInMs % (1000 * 60)) / 1000).toString().padStart(2, '0');
  //
  //         this.setState({ currentDuration: `${hours}:${minutes}:${seconds}` });
  //
  //         // If timeOut exists, clear any interval updating currentDuration
  //         if (timeOut && this.durationInterval) {
  //             clearInterval(this.durationInterval);
  //             this.durationInterval = null;
  //         }
  //     }
  // };

  renderSessionInfo = () => {
    const { timeIn, timeOut, currentDuration } = this.state;

    return (
      <div className="session-info">
        <AccessTimeIcon
          style={{ fontSize: 60, color: '#2596be', marginBottom: '1rem' }}
        />

        {timeIn && (
          <p>
            <b>Date:</b>{' '}
            { `${timeIn.toLocaleDateString('en-GB', {
                  weekday: 'long',
                })} ${String(timeIn.getDate()).padStart(2, '0')}/${String(
                  timeIn.getMonth() + 1
                ).padStart(2, '0')}/${timeIn.getFullYear()}`
              }
          </p>
        )}

        <p>
          <b>Clock In:</b>{' '}
          {timeIn ? timeIn.toLocaleTimeString() : 'Not clocked in yet'}
        </p>
        <p>
          <b>Clock Out:</b>{' '}
          {timeOut ? timeOut.toLocaleTimeString() : 'Not clocked out yet'}
        </p>

        {this.state.timeIn && !this.state.timeOut && (
          <p className="duration">
            Current Session: <strong>{currentDuration}</strong>
          </p>
        )}

        {this.state.timeOut && (
          <p className="duration">
            Total Time Worked: <strong>{currentDuration}</strong>
          </p>
        )}
      </div>
    );
  };

  displayTable = () => {
    return (
      <div>
        <div className="clock-in-out-container" style={{ padding: '1rem' }}>
          <p className="duration">
            {this.getGreeting()}, <strong> {this.props.user.firstname}!</strong>
          </p>

          <div className="actions">
            <Button
              variant="outlined"
              className="check-in-btn"
              onClick={() => this.clockIn()}
              // disabled={!!this.state.timeIn && !this.state.timeOut}
              disabled={this.state.clockInProcessing || (!!this.state.timeIn && !this.state.timeOut)}
            >
              Clock In
            </Button>
            <Button
              className="check-out-btn"
              variant="contained"
              onClick={this.handleClockOutClick}
              disabled={!this.state.timeIn || !!this.state.timeOut}
            >
              Clock Out
            </Button>
          </div>

          {this.renderSessionInfo()}
        </div>
      </div>
    );
  };

  render() {
    return (
      <React.Fragment>
        {/*<ErrorFeedbackBar/>*/}
        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />
        <TopToolbar pageName={CLOCK_IN_OUT} />

        <Dialog open={this.state.isDialogOpen} onClose={this.cancelClockOut}>
          <DialogTitle>Confirm Clock Out</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to clock out?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.cancelClockOut} color="primary">
              No
            </Button>
            <Button onClick={this.confirmClockOut} color="primary" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>

        {this.displayTable()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
    status: statusSelector(state),
    user: userInfoSelector(state),
    clockRecord: clockRecordSelector(state),
})


const actionCreators = {
    clearStatus,
    clockIn,
    clockOut,
    loadClockRecords
}

export default withShipment({
    actionCreators,
    mapStateToProps
}, ClockInOut);